export const sharedLocale = {
  // Grid
  'common.grid.columnName.actions': 'Actions',

  // Buttons
  'common.button.confirm': 'Confirm',
  'common.button.saving': 'Saving',
};
